import {
  GET_ALL_LITERATURE,
  GET_ALL_MAILS,
  GET_EMAIL_AND_LITERATURE_CASES,
  GET_ONE_EMAIL_AND_LITERATURE_CASES,
  CREATE_ISREADEMAIL,
  GET_EMAIL_CONTENT,
  GET_LITERATURE_CONTENT
} from '../types'

const INITIAL_STATE = {
  allmails: [],
  mailcount: null,
  mailcountUnread: null,
  mailcountRead: null,
  allEmailandLiteratureCases: [],
  getOneEmailandLiteratureCase:[],
  getEmailContent: {},
  getLiteratureContent: {},
  literatureLists: []
}

const emailReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_MAILS:
      return {
        ...state,
        allmails: payload.data,
        mailcount: payload?.data?.totalEmails,
        mailcountUnread: payload?.data?.unreadCount,
        mailcountRead: payload?.data?.readCount,
      }

    case GET_EMAIL_AND_LITERATURE_CASES:
      return {
        ...state,
        allEmailandLiteratureCases: payload.data,
      }
    case GET_ONE_EMAIL_AND_LITERATURE_CASES:
      return {
        ...state,
        getOneEmailandLiteratureCase: payload.data,
      }
    case GET_ALL_LITERATURE:
      return {
        ...state,
        literatureLists: payload.data,
      }
    case CREATE_ISREADEMAIL:
      return {
        ...state,
        allmails: {
          ...state.allmails,
          data: state?.allmails?.data?.map(email =>
            email.date === payload?.data?.date ? { ...email, isRead: true } : email
          ),
        },
        mailcountUnread: Math.max(0, (state.mailcountUnread || 0) - 1),
        mailcountRead: (state.mailcountRead || 0) + 1,
      }
    case GET_EMAIL_CONTENT:
      return {
        ...state,
        getEmailContent: payload.data,
      }
    case GET_LITERATURE_CONTENT:
      return {
        ...state,
        getLiteratureContent: payload.data,
      }
    default:
      return state
  }
}

export default emailReducer
